import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'

import {
  formatCurrency,
  getReverseWages,
  loadBudget,
  updateReverseBudgetSalary
} from '../../actions/assessments/budget'
import BudgetFooterBar from '../../components/assessment/budget/BudgetFooterBar'
import { browserHistory, logError } from '../../Routes'
import { updatePageTitle } from '../../actions/pageInfo'
import { useQuery, useTitleChange } from '../../util/hooks'

const BudgetReverse = props => {
  const {
    questions,
    dispatch,
    currentRound,
    responses,
    county,
    rounds,
    reverseWage,
    occupation
  } = props
  const coalesceWage = (wage1, wage2, naMsg) => {
    const w = coalesce(wage1, wage2)

    if (!w) {
      return naMsg
    }
    //console.log(w)

    return formatCurrency(w)
  }
  const coalesce = (wage1, wage2) => {
    return wage1 ? wage1.amount : wage2 ? wage2.amount : null
  }
  const addVal = inp => {
    return inp || inp === 0 ? inp.amount : null
  }
  const calcPct = (v, max) => {
    return 100 * (v / max)
  }
  const [amount, setAmount] = useState(reverseWage?.annualMean?.amount ?? 0)
  const qs = useQuery()

  useTitleChange(dynamicValues.budgetTitle)
  useEffect(() => {
    dispatch(loadBudget()).then(b => {
      dispatch(getReverseWages(qs.onetSoc))
    })
  }, [loadBudget, getReverseWages, qs.onetSoc])

  useEffect(() => {
    setAmount(reverseWage?.annualMean?.amount)
  }, [reverseWage?.annualMean?.amount])

  const maxSalary = 200000
  const ticks = [
    0,
    ...[
      addVal(reverseWage?.annual10),
      addVal(reverseWage?.annual25),
      addVal(reverseWage?.annualMean),
      addVal(reverseWage?.annual75),
      addVal(reverseWage?.annual90)
    ].filter(a => !!a),
    maxSalary
  ]
  const tickPcts = ticks.map(t => calcPct(t, maxSalary))

  console.log(
    ticks,
    ticks.map(t => formatCurrency(t))
  )

  const topWage = (
    <b key="topWage">
      {coalesceWage(reverseWage?.annual90, reverseWage?.annual75, t`n/a`)}
    </b>
  )
  const bottomWage = (
    <b key="bottomWage">
      {coalesceWage(reverseWage?.annual10, reverseWage?.annual25, t`n/a`)}
    </b>
  )
  const meanWage = (
    <b key="meanWage">{coalesceWage(reverseWage?.annualMean, null, t`n/a`)}</b>
  )
  const occLink = reverseWage?.occupation && (
    <a className="bold" href={reverseWage.occupation.url}>
      {reverseWage.occupation.title}
    </a>
  )
  const occSpecific = reverseWage?.occupation ? jt`for the occupation ${occLink}` : null
  const occTitle = reverseWage?.occupation?.title
  const loc = reverseWage?.location

  return (
    <div className="container budget">
      <div>
        <div className="occupation">
          <p className="removable nooccspecified question">{jt`You are about to begin a budget${occSpecific}.`}</p>
          <p>
            {reverseWage?.occupation
              ? jt`Most ${occTitle} in ${loc} make between ${bottomWage} and ${topWage}.`
              : jt`The average worker across all occupations in ${loc} make between ${bottomWage} and ${topWage}.`}{' '}
            {t`Depending on your experience, you can generally expect to make somewhere in this range.
                            You can enter your expected salary in the box below, or use the slider to select one of the common values and fill it in.`}
          </p>

          <div id="imgcontainer">
            <div className="low withicons"></div>
            <div className="med withicons"></div>
            <div className="high withicons"></div>
          </div>

          <div className="slider-holder">
            <ReactBootstrapSlider
              min={0}
              step={1000}
              max={maxSalary}
              selection="none"
              tooltip_position="bottom"
              formatter={formatCurrency}
              change={v => {
                //console.log(v)
                setAmount(v.target.value)
              }}
              value={amount}
              ticks={ticks}
              ticks_labels={ticks.map(t => formatCurrency(t))}
              ticks_positions={tickPcts}
            />
          </div>

          <div
            className="text-center"
            style={{ marginTop: '15px' }}
            id="wage-slider-desc">
            {jt`The average wage for this occupation is ${meanWage} per year`}
          </div>

          <br className="clear" />
        </div>
        <div id="budget-nav-controller">
          <form>
            <div className="left">
              <p>
                <label htmlFor="initialsalary">{t`Expected Annual Salary:`}</label>
              </p>
              <div className="input-group">
                <span className="input-group-addon">$</span>
                <input
                  type="text"
                  onChange={v => setAmount((v.target.value || '').replace(/[^0-9]/g, ''))}
                  className="text-input initialsalary response"
                  id="annualsalary"
                  value={amount}
                />
              </div>
              <p></p>
            </div>
            <div className="right" style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <input
                  id="nextbutton"
                  type="button"
                  className="btn btn-success btn-cta-lg"
                  onClick={() => props.onNext(amount)}
                  value={t`Next Section`}
                />
              </div>
              <div className="nextsection">
                <div className="withicons icon locationicon"></div>
                <div className="name">{t`Location`}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br />
      <BudgetFooterBar
        currentRound={currentRound}
        responses={responses}
        occupation={occupation}
        rounds={rounds}
        county={county}
      />
    </div>
  )
}

export default connect(
  state => {
    console.log(state.assessments.budget)

    return {
      ...state.assessments.budget.main.result,
      rounds: state.assessments.budget.main.rounds,
      reverseWage: state.assessments.budget.reverseWage.result
    }
  },
  dispatch => ({
    onNext: salary => {
      return dispatch(updateReverseBudgetSalary(salary))
        .then(() => browserHistory.push('/budget/county'))
        .catch(() => alert('Could not update salary'))
    },
    dispatch
  })
)(BudgetReverse)
